import { useState } from "react";
import { Plus, Minus, ChevronUp } from "lucide-react";
import { useTickets } from "./TicketContext";

import { useNavigate } from "react-router-dom";  

export default function TicketBooking() {
 
  const { tickets, setTickets, totalTickets, totalPrice } = useTickets();
 
  const handleTicketChange = (type, increment) => {
    setTickets((prev) => ({
      ...prev,
      [type]: Math.max(0, prev[type] + increment),
    }));
  };

  const navigate = useNavigate()

  return (

    
    <div className="flex flex-col  md:px-52 pb-24   items-center p-6 bg-[#f8f5eb] min-h-screen">

 

      <div className="relative w-full p-6 mt-10 bg-white max-w-7xl rounded-2xl">
        <h2 className="text-3xl font-bold text-[#003400] mb-5 font-georgia">Tickets for non-residents</h2>
        <div className="mt-4">
          <h3 className="font-semibold text-[#003400] text-xl font-georgia">Current Promotion</h3>
          <div className="inline-block w-full px-4 py-2   text-md font-bold text-[#003400]  mb-5 mt-10 bg-[#FFCC00] rounded-2xl shadow-md ">
            Online Exclusive: Kids enter free with every 2 paying Adults.
          </div>
          <div className="flex items-center justify-between pb-3 mt-4 border-b">
            <span className="font-bold font-georgia">2 Adults + Free 1 Child</span>
            <div className="flex items-center space-x-2">
            <div className="text-right">
              <span className="text-lg font-bold text-gray-800 font-georgia">S$86.00</span>
              <div className="text-sm text-gray-500 line-through font-georgia">UP: S$117.00</div>
            </div>
              <button onClick={() => handleTicketChange("promo", -1)} className="flex items-center justify-center w-10 h-10 p-2 bg-white border rounded-full shadow">
                <Minus size={16} />
              </button>
              <input type="text" value={tickets.promo} readOnly className="w-16 p-4 text-xl text-center bg-white border rounded-lg shadow" />
              <button onClick={() => handleTicketChange("promo", 1)} className="flex items-center justify-center w-10 h-10 p-2 text-white bg-[#003400] border rounded-full shadow">
                <Plus size={16} />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <h3 className="font-semibold text-[#003400] text-xl font-georgia">Non-Resident Tickets</h3>
          {[{ label: "Adult", price: 43, type: "adult" }, { label: "Child", price: 31, type: "child" }].map((ticket) => (
            <div key={ticket.type} className="flex items-center justify-between pb-3 mt-4 border-b">
              <div>
                <span className="text-xl font-semibold ">{ticket.label}</span>
                {ticket.type === "child" && <div className="text-xs text-gray-500 font-georgia">Ages 3 to 12.</div>}
              </div>
              <div className="flex items-center space-x-2">
              <span className="text-lg font-bold text-gray-800">S${ticket.price}.00</span>
                <button onClick={() => handleTicketChange(ticket.type, -1)} className="flex items-center justify-center w-10 h-10 p-2 bg-white border rounded-full shadow">
                  <Minus size={16} />
                </button>
                <input type="text" value={tickets[ticket.type]} readOnly className="w-16 p-4 text-xl text-center bg-white border rounded-lg shadow 2- " />
                <button onClick={() => handleTicketChange(ticket.type, 1)} className="flex items-center justify-center w-10 h-10 p-2 text-white bg-[#003400]  border rounded-full shadow">
                  <Plus size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <button className="absolute p-2 text-white bg-green-900 rounded-full shadow-lg top-4 right-4">
          <ChevronUp size={16} />
        </button>
      </div>
      
      <div className="fixed bottom-0 left-0 right-0 flex items-center justify-end w-full p-4 bg-white md:px-52">
        <button className="mr-10 font-semibold text-gray-700 underline text-md font-georgia">Back</button>
        <button onClick={()=>navigate('/2')}
          className={`px-6 py-2 font-georgia text-md rounded-full font-semibold ${totalTickets > 0 ? 'bg-black text-white' : 'bg-gray-300 text-gray-500'}`} 
          disabled={totalTickets === 0}>
          NEXT
        </button>
      </div>
    </div>
  );
}
